module.exports = __webpack_public_path__ + "img/icon-gift.6668a556.png";